import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-dismiss after 4 seconds
    this.timeout = setTimeout(() => this.dismiss(), 4000)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.style.transition = "opacity 0.3s, transform 0.3s"
    this.element.style.opacity = "0"
    this.element.style.transform = "translateY(-0.5rem)"
    setTimeout(() => this.element.remove(), 300)
  }
}
